import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { has as _has, isEmpty as _isEmpty } from 'lodash';
import { useMobxStores } from '@stores/store';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PlayBtn from '@atoms/btn/PlayBtn';
import { useWindowSize } from 'usehooks-ts';

const SectionMedia = ({ mediaRef }) => {
  const { i18n, t } = useTranslation();
  const { settingStore } = useMobxStores();

  const location = useLocation();
  let query = queryString.parse(location.search);
  const [onActiveIndex, setOnActiveIndex] = useState(0);

  const { width } = useWindowSize();
  let sectionStyle = {};
  if (width > 1920) {
    sectionStyle = {
      backgroundImage: 'url(/img/v2/main/bg/bg_xhug_butter.png)',
      backgroundSize: '100%',
      backgroundPosition: 'top',
      backgroundRepeat: 'no-repeat',
    };
  } else {
    sectionStyle = {
      backgroundImage: 'url(/img/v2/main/bg/bg_pc_butter.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'top',
      backgroundRepeat: 'no-repeat',
    };
  }

  const boxStyle = {
    backgroundImage: 'url(/img/v2/main/media/pc_media_box.png)',
    backgroundSize: '100%',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
  };

  const arrayMediaTitle = [
    '이름 짓기',
    '로고 만들기',
    '퍼즐 만들기',
    '제작 후기',
  ];

  const arrayMedia = [
    '34u9lJWBLMc',
    'GeTdXJNxON4',
    'I6kNDR1MGBQ',
    'MG-KYIvBzzs',
  ];
  const handleClickChange = () => {
    settingStore.setCommonDialogState(true);
    settingStore.setCommonDialogSrcState(arrayMedia[onActiveIndex]);
  };

  useEffect(() => {}, []);

  return (
    <div
      className="media bg-[#fff] py-2 relative pb-[50px] lg:pt-[150px] xl:pt-[400px] hug:pb-[200px]"
      style={sectionStyle}
      ref={mediaRef}
    >
      <section className="max-w-[1200px] m-auto  pt-[35%] md:pt-[200px] hug:pt-[180px]">
        <div className="px-10 text-center">
          <p className="md:mt-[30px]  font-TmoneyRoundWind  font-extrabold  text-[#e5b522] #xxxs:text-3xl text-4xl xs:text-5xl md:text-6xl">
            {t('BTS')}
          </p>
          <p className=" font-TmoneyRoundWind  font-extrabold  text-[#e5b522] #xxxs:text-3xl text-4xl xs:text-5xl">
            {t('게임개발자 되다!')}
          </p>
          <p className="text-[#c5a43f]  text-md sm:text-xl md:text-2xl pt-2">
            {t('이름부터 로고, 퍼즐까지 함께한 과정을 알아봐요')}
          </p>
          <div
            className="relative  media-container pt-[26.5%] pb-[50%] px-[13.2%] "
            style={boxStyle}
          >
            <div className="cursor-pointer media-container-ratio">
              <div className="grid grid-cols-4  media-menu font-TmoneyRoundWind">
                {arrayMediaTitle &&
                  arrayMediaTitle.map((title, idx) => (
                    <div
                      key={`media_${idx}`}
                      className={`  ${onActiveIndex === idx ? 'active' : ''}`}
                      onClick={() => setOnActiveIndex(idx)}
                    >
                      <span className="font-extrabold leading-[1.1] text-sm sm:text-lg md:text-2xl xhug:text-3xl inline-block pb-0 xxs:pb-[10px] px-[2px]">
                        {t(arrayMediaTitle[idx])}
                      </span>
                    </div>
                  ))}
              </div>
              <div
                className="relative w-full h-[0] pb-[56.26%] overflow-hidden"
                onClick={handleClickChange}
              >
                <PlayBtn />
                <div className="pt-[1%] px-[2%]">
                  <img
                    src={`/img/v2/main/media/media_img_0${onActiveIndex}.jpg`}
                    alt=""
                    className=" object-cover rounded-[3px] border border-solid border-[#e5dd7d] w-full h-full "
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="absolute bottom-[12%] flex left-0 right-0 justify-center   ">
            <img src="/img/v2/main/mobile/butter_char.png" alt="" />
          </div>
          <div className="absolute bottom-[12%] flex left-0 right-0 justify-center   ">
            <a
              href="https://www.youtube.com/@IntheSEOM"
              target="_blank"
              className="#sm:mt-2 min-w-[250px] mx-[30%] sm:mx-[35%] py-1 w-full flex justify-center items-center bg-[#cb3c2e] rounded-full w-full text-[#fff] font-bold btn-shadow text-center py-3 xs:py-5 xs:text-2xl"
              rel="noreferrer"
            >
              {t('공식 유튜브')}
              <img
                src="/img/v2/svg/youtube.svg"
                alt=""
                className="inline-block max-h-[30px] ml-2"
              />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default observer(SectionMedia);
